import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { INzMessageType } from '@ascschool/interface/setting';
import { AuthService, LoginPayload } from '@ascschool/core/auth/auth.service';
import { ProjectService } from '@ascschool/project/state/project/project.service';
import { error } from 'protractor';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AuthQuery } from '@ascschool/core/auth';
import { NzCarouselComponent } from 'ng-zorro-antd/carousel';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, AfterViewInit {
  @ViewChild('myCarousel', { static: false }) myCarousel: NzCarouselComponent;
  array = [1, 2, 3, 4];
  arraySurvey = [
    { img: '/assets/survey/ks001.jpg', link: 'phieuhoigv', title: 'KHẢO SÁT GIÁO VIÊN' },
    { img: '/assets/survey/KSNKT.png', link: 'phieuhoinkt', title: 'KHẢO SÁT NGƯỜI KHUYẾT TẬT' },
  ];
  indexCarousel: number;
  // effect = 'scrollx';
  response: any;
  returnUrl: string;
  loadingLogin = false;
  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });
  validateMode = false;
  hidePassword = true;
  showAppmobile = false;
  formLoginOpened = true;
  typeUserLoginName: string;
  validateForm!: FormGroup;
  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private route: ActivatedRoute,
    private _authService: AuthService,
    private _authQuery: AuthQuery,
    private _projectService: ProjectService,
    private fb: FormBuilder,
    private deviceService: DeviceDetectorService
  ) { }

  device: any;
  ngAfterViewInit(): void {
    this.showAppmobile = true;
  }

  ngOnInit() {
    this.device = this.deviceService.getDeviceInfo();
    this.indexCarousel = this.arraySurvey.length - 1;
    this.loginForm.valueChanges.subscribe(() => {
      if (this.loginForm.valid) {
        this.validateMode = false;
      } else {
        this.validateMode = true;
      }
    });
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this._authQuery.isLoggedIn()) {
      this.router.navigate([this.returnUrl]);
    }

    this.validateForm = this.fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [true]
    });
  }
  validate(controlName: string) {
    return this.loginForm.controls[controlName].hasError('required') && this.validateMode;
  }
  login() {
    if (!this.loadingLogin) {
      this.validateMode = true;
      if (this.loginForm.valid) {
        const _this = this;
        this.loadingLogin = true;
        const loginForm = this.loginForm.value;
        this._authService
          .login(new LoginPayload(loginForm.username, loginForm.password, 0, this.device))
          .subscribe(
            (data) => {
              _this.response = data;
              if (data.status === 0) {
                _this.router.navigate(['/project']);
                this.utilsService.showNotification(INzMessageType.Success, 'Đăng nhập thành công', 3000);
              } else {
                this.loadingLogin = false;
                this.utilsService.showNotification(INzMessageType.Error, 'Sai thông tin đăng nhập!', 3000);
              }
            },
            () => {
              this.loadingLogin = false;
              this.utilsService.showNotification(INzMessageType.Warning, 'Đăng nhập thất bại', 3000);
            }
          );
        this._projectService.getProject();
      }
    }
  }
  openLoginForm(typeUserLoginName: string) {
    this.typeUserLoginName = typeUserLoginName;
    this.formLoginOpened = true;
  }
  blurPassword() {
    document.getElementById('password').blur();
  }

  submitForm(): void {
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  handlerCarousel() {
    if (this.indexCarousel !== this.myCarousel.activeIndex) {
      let index = this.arraySurvey.length - 1 - this.myCarousel.activeIndex;
      this.router.navigate(['/' + this.arraySurvey[index].link]);
    }
  }
  carouselChange(event) {
    this.indexCarousel = event.to;
    setTimeout(() => {
      this.indexCarousel = event.from;
    }, 300);
  }
  handlerPreSlide() {
    this.myCarousel.pre();
  }
  handlerNextSlide() {
    this.myCarousel.next();
  }
}
